<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		d="M3.46167 8.46469C3.46167 9.84355 3.95075 11.0221 4.92892 12.0002L7.75734 14.8287L9.17156 13.4144L6.34313 10.586C5.75387 9.99676 5.45925 9.28965 5.45925 8.46469C5.45925 7.63974 5.75387 6.93263 6.34313 6.34337C6.93239 5.75412 7.63949 5.45949 8.46445 5.45949C9.28941 5.45949 9.99651 5.75412 10.5858 6.34337L13.4142 9.1718L14.8284 7.75759L12 4.92916C11.0218 3.951 9.84331 3.46191 8.46445 3.46191C7.08559 3.46191 5.90708 3.951 4.92892 4.92916C3.95075 5.90733 3.46167 7.08584 3.46167 8.46469Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M9.87866 8.46469L8.46445 9.87891L14.1213 15.5358L15.5355 14.1215L9.87866 8.46469Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M13.4142 17.6571L10.5858 14.8287L9.17156 16.2429L12 19.0713C12.9781 20.0495 14.1567 20.5385 15.5355 20.5385C16.9144 20.5385 18.0929 20.0495 19.0711 19.0713C20.0492 18.0931 20.5383 16.9146 20.5383 15.5358C20.5383 14.1569 20.0492 12.9784 19.0711 12.0002L16.2426 9.1718L14.8284 10.586L17.6568 13.4144C18.2461 14.0037 18.5407 14.7108 18.5407 15.5358C18.5407 16.3607 18.2461 17.0678 17.6568 17.6571C17.0676 18.2463 16.3605 18.541 15.5355 18.541C14.7106 18.541 14.0035 18.2463 13.4142 17.6571Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
